
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"11"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 .5)","fill":"none"}},[_c('g',{attrs:{"transform":"translate(0 .5)"}},[_c('rect',{attrs:{"width":"10","height":"10","rx":"2"}}),_c('rect',{attrs:{"width":"9","height":"9","rx":"1.5","transform":"translate(.5 .5)","stroke":"#404d64"}})]),_c('line',{attrs:{"x2":"9.503","transform":"translate(.248 4.283)","stroke":"#404d64"}}),_c('g',{attrs:{"transform":"translate(2.801)","stroke":"#404d64","stroke-linecap":"round"}},[_c('line',{attrs:{"y1":"1.629"}}),_c('line',{attrs:{"y1":"1.629","transform":"translate(4.398)"}})])])])
          )
        }
      }
    